import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import type { DeleteConfirmDialogProps } from './types';
import { LABELS, MESSAGES } from './constants';

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  storeName,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <Modal
      open={open}
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: '#ff4d4f', marginRight: '8px' }} />
          {LABELS.DELETE_STORE}
        </span>
      }
      onOk={onConfirm}
      onCancel={onCancel}
      okText={LABELS.DELETE}
      cancelText={LABELS.CANCEL}
      okButtonProps={{ danger: true, loading }}
      confirmLoading={loading}
    >
      <p>{MESSAGES.DELETE_CONFIRMATION}</p>
      {storeName && (
        <p>
          <strong>Store: {storeName}</strong>
        </p>
      )}
    </Modal>
  );
};

export default React.memo(DeleteConfirmDialog);
